import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap';

function AddExperienceModal({show,handleClose}) {

  return (
    <>
    <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header className="justify-content-center">
              <h2 className="modal-title fs-5">Feature Your Visited Parks</h2>
            </Modal.Header>
            <Modal.Body>
              <Col md={12}>
                <form
                  id="experience-form"
                  action="/profile/default/create"
                  method="post"
                >
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <label
                          className="Modal_label"
                          htmlFor="userexperienceform-parks"
                        >
                          Parks
                        </label>
                      </div>
                    </Col>
                  </Row>
    
                  <Row className="row py-2">
                    <Col lg={12}>
                      <div className="creat-safri d-flex justify-content-end">
                        <button
                          type="button"
                          className="cancel_btn"
                          data-bs-dismiss="modal"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="safari_create font_set w-auto ms-2"
                        >
                          Create{" "}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Modal.Body>
          </Modal>
    </>
  )
}

export default AddExperienceModal;